<template>
  <div class="recharge_left capital_first">
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <div style="float: left">
        <span class="title" >{{$t('pc.trading.balance')}}：{{amountPlus}}{{$t('pc.home.USD')}}</span>
        </div>
        <div style="float: right">
          <div >
            <router-link style="background-color: red;color: white;padding: 5px 20px 5px 20px; border-radius: 25px" :to="{name:'Protocol',params:{type:21}}">{{$t('pc.friendcoupon.instructions_for_use')}}</router-link>
          </div>
        </div>
      </div>
          <el-table
            :data="all_coupon"
            stripe
            size="mini"
            style="width: 100%; font-size: 16px">
            <el-table-column
              prop="name"
              align="center"
              :label="$t('pc.friendcoupon.gift_date')">
            </el-table-column>
            <el-table-column
              prop="short"
              align="center"
              :label="$t('pc.friendcoupon.expiration_date')">
            </el-table-column>
            <el-table-column
              prop="number"
              align="center"
              :label="$t('pc.trading.amount')">
              <template slot-scope="scope">
                <p style="font-size: 15px">{{ scope.row.amount }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="surplus"
              align="center"
              :label="$t('pc.trading.status')">
              <template slot-scope="scope">
                <p style="font-size: 15px">{{ scope.row.statustext }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="frozen"
              align="center"
              :label="$t('pc.friendcoupon.promotional_qr_code')">
              <template slot-scope="scope">
                <p v-if="scope.row.status === 1" @click="agencyQr(scope.row.coupon,scope.row.amount)"><span style="font-size: 15px;color: #606266;font-weight: 600;cursor: pointer">{{ $t('pc.friendcoupon.details') }}></span></p>
              </template>
            </el-table-column>
          </el-table>
    </el-card>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "friendcoupon",
  data(){
    return{
      all_coupon:[],
      amountPlus : 0
    }
  },
  created() {
    this.$store.state.accountType = 8;
  },
  mounted(){
    this.getAllDepot();
  },
  methods:{
    getAllDepot() {
      let that = this;
      that.$http({
        url: "/",
        method: "post",
        data: {
          nozzle: 'friend_coupon',
          token: window.sessionStorage.getItem('token'),
        }
      })
        .then(function(res) {
          let resData = res.data;
          if (resData.code == 1) {
            that.all_coupon = resData.data;

            for (let i = 0; i < that.all_coupon.length; i++) {
             if(that.all_coupon[i].status === 1){
               that.amountPlus = that.amountPlus + that.all_coupon[i].amount;
             }
            }
          } else if (resData.code == 0 || resData.code == -1) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
    },

    agencyQr(id,no){
      this.$store.commit("couponAmountCheck", no);
      this.$store.commit("couponNoCheck", id);

      this.$router.push({
        path: "/myaccount/agency"
      });
      // this.$store.state.couponNo = id;
      // this.$store.state.couponAmount = no;
    }
  },
}
</script>

<style scoped>
.changePage{
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/friendcoupon.vue